import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  IconButton,
  TextField,
  withStyles,
  InputAdornment,
} from '@material-ui/core'
import { Search, Settings } from '@material-ui/icons'
import { search } from 'actions/view'
import { toggleDialog } from 'actions/view'

export default connect(
  state => ({
    searchState: state.search,
    count: state.view.count,
    dialogOpen: state.view.dialogs?.AdvancedSearch?.open,
  }),
  dispatch => bindActionCreators({ search, toggleDialog }, dispatch),
)(
  withStyles(theme => ({
    root: {
      color: '#fff',
    },
    underline: {
      '&:after': {
        borderBottom: '2px solid #fff',
      },
    },
    buttonFocused: {
      backgroundColor: theme.palette.green,
      '&:hover': {
        backgroundColor: '#15a53a',
      },
    },
  }))(
    class SearchComponent extends Component {
      constructor(props) {
        super(props)
        this.textInput = createRef()

        this.state = {
          search: '',
          preventBlur: false,
        }
      }

      componentDidUpdate(prevProps) {
        if (
          prevProps.dialogOpen !== this.props.dialogOpen &&
          !this.props.dialogOpen
        ) {
          this.setState({ preventBlur: false })
        }
      }

      componentWillUnmount() {
        this.setState({ search: '' })
        this.props.search(null)
      }

      render() {
        const handleAdornmentClick = e => {
          console.log('handleAdornmentClick')
          // Perform the action for the adornment click
          return this.props.toggleDialog?.({
            open: true,
            dialog: 'AdvancedSearch',
            options: {
              keys: this.props.keys,
              sort: this.props.sort,
              nonSortableKeys: this.props.nonSortableKeys,
            },
          })
        }

        const handleMouseDown = event => {
          // Prevent default to keep focus on TextField
          event.preventDefault()
          this.setState({ preventBlur: true })
        }

        const field = (
          <TextField
            InputProps={{
              classes: {
                root: this.props.classes.root,
                underline: this.props.classes.underline,
              },
              inputRef: this.textInput,
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    style={{ padding: 6 }}
                    aria-label="Advanced settings"
                    onClick={handleAdornmentClick}
                    onMouseDown={handleMouseDown}
                  >
                    <Settings style={{ color: '#fff' }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            onChange={e => this.setState({ search: e.target.value })}
            onBlur={() => {
              console.log('onBlur')
              if (this.state.search === '' && !this.state.preventBlur) {
                this.props.search(null)
              }
            }}
            value={this.state.search}
            onKeyDown={e => {
              if (e.keyCode === 13) {
                this.props.search(e.target.value)
              }
            }}
          />
        )

        return (
          <div style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
            {this.props.searchState !== null ? (
              field
            ) : (
              <div style={{ color: '#fff', fontSize: 14, marginTop: 9 }}>
                {`Total: ${
                  typeof this.props.count !== 'number' ? '--' : this.props.count
                }`}
              </div>
            )}
            <IconButton
              style={{ padding: 6 }}
              classes={
                this.props.searchState === null
                  ? {}
                  : { root: this.props.classes.buttonFocused }
              }
              onClick={() => {
                if (this.state.search) {
                  this.props.search(this.state.search)
                } else {
                  Promise.resolve(this.props.search('')).then(() => {
                    this.textInput.current.focus()
                  })
                }
              }}
            >
              <Search style={{ color: '#fff' }} />
            </IconButton>
          </div>
        )
      }
    },
  ),
)
